import { Button, DatePicker, Radio, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SelectInput from "../../../components/SelectInput";
import AppInput from "../../../components/AppInput";
import TextArea from "antd/es/input/TextArea";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { garbageTypeTwo, methodofDisposal } from "../../../Data/data";
import { ErrorToast } from "../../../widgets/AppToast";
import moment from "moment";
import { UploadOutlined } from "@ant-design/icons";
import useDocumentUpload from "../../../hooks/useDocumentUpload";

function ViewGarbageLogTwo() {
  const { garbage_id } = useParams();
  const [errors, set_errors] = useState({});
  const [garbage_type, set_garbage_type] = useState("");
  const [qtty_disposed, set_qtty_disposed] = useState("");
  const [method_of_disposal, set_method_of_disposal] = useState("");
  const [if_disposed, set_If_disposed] = useState(false);
  const [free_Text, set_Free_Text] = useState("");
  const [logDate, set_LogDate] = useState(null);
  const [position, setPosition] = useState("");
  const [digitalSignatureIncharge, setDigitalSignatureIncharge] = useState("");
  const [initialDocument, setInitialDocument] = useState([]);
  const { documentList, handleDocumentChange } =
    useDocumentUpload(initialDocument);

  const VIEW_GARBAGE_LOGBOOK_APIS = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("garbage_record_id", atob(garbage_id));
      FORM_DATA.append("request_type", "view");
      FORM_DATA.append("garbage_part", "2");
      post(ApiURL.company_single_garbage_record, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const garbageData = res?.record;
          set_garbage_type(garbageData?.garbage_type);
          set_qtty_disposed(garbageData?.quantity_disposed);
          set_method_of_disposal(garbageData?.method_of_disposal);
          set_If_disposed(garbageData?.disposed ? "yes" : "no");
          set_Free_Text(garbageData?.comment);
          set_LogDate(garbageData?.log_date_time);
          setDigitalSignatureIncharge(garbageData?.signature);
          setPosition(garbageData?.position);
          setInitialDocument(garbageData?.files);
        } else {
          const errors = res?.errors || {};
          set_errors(errors);
        }
      });
    } catch (error) {
      ErrorToast("Error message!", "Garbage record details filed !");
    }
  };

  useEffect(() => {
    VIEW_GARBAGE_LOGBOOK_APIS();
  }, []);

  const getDocUrl = (file) => {
    if (file.url) return file.url;
    if (file.originFileObj) return URL.createObjectURL(file.originFileObj);
    return null;
  };

  const handlePreviews = async (file) => {
    const url = getDocUrl(file);
    if (!url) {
      ErrorToast("Error mesaage", "No preview available for this file");
      return;
    }
    window.open(url, "_blank");
  };

  return (
    <>
      <div className="white-container">
        <br />
        <h3>Garbage Logbook Information </h3>
        <br />
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time</label>
              <DatePicker
                disabled
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="Select Date & Time"
                value={logDate ? moment(logDate, "YYYY-MM-DD HH:mm:ss") : null}
                // onChange={onChangeDateTime}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div className="col-6">
            <SelectInput
              disabled
              label="Garbage Type"
              value={garbage_type}
              placeholder=" -- Garbage Type  -- "
              style={{ width: "100%" }}
              onChange={(value) => set_garbage_type(value)}
              options={garbageTypeTwo}
              errors={errors?.selectedTank}
            />
          </div>
        </div>

        <div className="row" style={{ marginBottom: "10px" }}>
          <div className="col-6">
            <label className="block-label">If disposed</label>
            <Radio.Group
              disabled
              value={if_disposed}
              onChange={(e) => set_If_disposed(e.target.value)}
            >
              <Radio value={"no"}>NO</Radio>
              <Radio value={"yes"}>Yes</Radio>
            </Radio.Group>
            {errors?.voyage_status && (
              <span style={{ color: "red" }}>{errors?.voyage_status}</span>
            )}
          </div>
        </div>
        {if_disposed === "yes" && (
          <>
            <div className="row">
              <div className="col-6">
                <SelectInput
                  disabled
                  label="Method of Disposal"
                  placeholder=" -- Method of Disposal  -- "
                  style={{ width: "100%" }}
                  value={method_of_disposal}
                  onChange={(value) => set_method_of_disposal(value)}
                  options={methodofDisposal}
                  errors={errors?.method_of_disposal}
                />
              </div>
              <div className="col-6">
                <AppInput
                  disabled
                  label="Qnty disposed (m3)"
                  placeholder="Qnty disposed"
                  value={qtty_disposed}
                  onChange={(e) => set_qtty_disposed(e.target.value)}
                  errors={errors.qtty_disposed}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <AppInput
                  disabled
                  label="Position"
                  placeholder="Enter Position"
                  value={position}
                  onChange={(e) => setPosition(e.target.value)}
                  errors={errors?.position}
                />
              </div>
              <div className="col-6">
                <AppInput
                  disabled
                  label="Digital Signature (Incharge)"
                  placeholder="Enter Digital Signature"
                  value={digitalSignatureIncharge}
                  onChange={(e) => setDigitalSignatureIncharge(e.target.value)}
                  errors={errors?.digitalSignatureIncharge}
                />
              </div>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>
                Garbage Comments: (e.g. start/stop time and position of
                incineration; general)
              </label>
              <TextArea
                rows={1}
                placeholder="Garbage Comments"
                maxLength={1000}
                value={free_Text}
                onChange={(e) => set_Free_Text(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div
              className="input-box"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "flex-start",
              }}
            >
              <label>Select File</label>
              <Upload
                accept=".pdf,.doc,.docx,.xls,.xlsx"
                multiple
                fileList={documentList}
                onChange={handleDocumentChange}
                onPreview={handlePreviews}
                beforeUpload={() => false}
                listType="picture"
                disabled
              >
                <Button
                  disabled
                  icon={<UploadOutlined />}
                  type="primary"
                  style={{
                    borderRadius: "50%",
                    padding: "10px",
                    width: "40px",
                    height: "40px",
                    marginLeft: "10px",
                  }}
                ></Button>
              </Upload>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewGarbageLogTwo;
